import React from "react";
import { useStepData } from "../../../hooks/useStepData";
import { useFunnelNavigation } from "../../../hooks/useFunnelNavigation";
import { SelectionButton } from "../../common/SelectionButton";
import { StepHeader } from "../../common/StepHeader";

export function SingleSelect({ config }) {
  const { data, updateStepData } = useStepData(config.field);
  const { nextStep } = useFunnelNavigation();

  const handleSelect = (optionId) => {
    updateStepData(optionId);
    setTimeout(() => {
      nextStep();
    }, 220);
  };

  return (
    <div className="px-4">
      <StepHeader
        title={config.title}
        subtitle={config.subtitle}
        order={config.headerOrder}
      />

      <div className="space-y-3">
        {config.options.map((option) => (
          <SelectionButton
            key={option.id}
            emoji={option.emoji}
            title={option.title || option.text}
            subtitle={option.subtitle}
            selected={data === option.id}
            onClick={() => handleSelect(option.id)}
          />
        ))}
      </div>
    </div>
  );
}
